import React from 'react';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './DraftNotifier.css';

import { headerStyle, getThemeFromLocalStorage } from '../utils/utils';


class DraftNotifier extends React.Component {

  state = {
    colors: 'normal',
    style: {},
    visible: false,
    message: "",
  };

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let style = {border: null};

    if (colors !== 'normal') {
      style = {
        color: headerStyle[colors].color,
        border: `1px solid ${headerStyle[colors].color}`,
        backgroundColor: headerStyle[colors].backgroundColor,
      };
    }

    this.setState({ colors, style }, () => {
      window.addEventListener("draft:saved", this.showToast);
      window.addEventListener("draft:loaded", this.showToast);
    });
  }

  componentWillUnmount() {
    window.removeEventListener("draft:saved", this.showToast);
    window.removeEventListener("draft:loaded", this.showToast);
  }

  showToast = (event) => {

    let message = "Wersja robocza zapisana";

    if (event.type && event.type === "draft:loaded") {
      message = "Wczytano wersję roboczą formularza!";
    }

    this.setState({ 
      visible: true,
      message
    });

    setTimeout(() => {
      this.setState({ visible: false });
    }, 2000);
  };

  render() {
    if (!this.state.visible) return null;

    return (
      <div className={s.draftToast} style={this.state.style}>
        <i className="fa fa-save" style={{ marginRight: '10px' }}></i>
        {this.state.message}
      </div>
    );
  }
}

export default withStyles(s)(DraftNotifier);



// WEBPACK FOOTER //
// src/components/DraftManagement/DraftNotifier.js